
import { motion } from "framer-motion";
import { Gift, Tag, Percent } from "lucide-react";

export default function OffersPage() {
  return (
    <div className="min-h-screen flex flex-col">
      <main className="flex-grow pt-24 pb-24">
        <div className="container mx-auto px-4 py-12">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="max-w-4xl mx-auto"
          >
            <h1 className="text-4xl md:text-5xl font-bold font-playfair mb-8">Offer Details</h1>
            <div className="prose max-w-none space-y-6 text-gray-700">
              <p>
                Discover our current offers and promotions. We regularly update our deals to bring you
                the best value on premium jewellery.
              </p>
              <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-2xl p-8 my-8">
                <div className="flex items-center gap-4 mb-4">
                  <Gift className="w-12 h-12 text-purple-600" />
                  <div>
                    <h2 className="text-2xl font-bold">Sign Up Discount</h2>
                    <p className="text-gray-600">Get ₹100 OFF on your first order</p>
                  </div>
                </div>
                <p className="text-gray-700">
                  New customers can enjoy ₹100 off on their first order when they sign up for our
                  newsletter. This discount is automatically applied at checkout.
                </p>
              </div>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Current Offers</h2>
              <ul className="list-disc list-inside space-y-2">
                <li><strong>Free Shipping:</strong> On all prepaid orders above ₹500</li>
                <li><strong>Seasonal Sales:</strong> Up to 60% off on selected collections</li>
                <li><strong>Bulk Discounts:</strong> Special pricing on orders above ₹10,000</li>
                <li><strong>Loyalty Rewards:</strong> Earn points on every purchase</li>
              </ul>
              <h2 className="text-3xl font-bold font-playfair mt-8 mb-4">Terms & Conditions</h2>
              <ul className="list-disc list-inside space-y-2">
                <li>Offers cannot be combined with other promotions</li>
                <li>Discounts are valid for a limited time only</li>
                <li>We reserve the right to modify or cancel offers at any time</li>
                <li>Some products may be excluded from certain offers</li>
              </ul>
            </div>
          </motion.div>
        </div>
      </main>
    </div>
  );
}
